export const Loading1Icon = ({
  width = 40,
  height = 40,
  title = "Loading",
  ...rest
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 80 80"
    fill="none"
    {...rest}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M41.344 26.586c11.307 0 20.473-2.776 20.473-6.2 0-3.424-9.166-6.2-20.473-6.2-11.306 0-20.472 2.776-20.472 6.2 0 3.424 9.166 6.2 20.472 6.2Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M20.872 20.386V58.95c0 3.423 9.166 6.2 20.472 6.2 11.306 0 20.473-2.777 20.473-6.2V20.386"
    />
    <path
      fill="#5DCDFF"
      d="M41.345 56.762c2.43 0 4.402-1.928 4.402-4.306 0-2.379-1.971-4.307-4.402-4.307-2.432 0-4.403 1.928-4.403 4.307 0 2.378 1.971 4.306 4.403 4.306Z"
    />
  </svg>
);
